<template>
  <div>
    <div class="vx-row mb-4">
      <h5 class="ml-4 mr-4">Date Range</h5>
      <date-range-picker
        ref="picker"
        :opens="'right'"
        :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
        :maxDate="date2"
        :timePicker="true"
        :showWeekNumbers="false"
        :showDropdowns="true"
        :autoApply="true"
        :appendToBody="false"
        :always-show-calendars="false"
        :linkedCalendars="true"
        v-model="dateRange"
        :control-container-class="'bg-transparent cursor-pointer'"
      >
        <template v-slot:input="picker" style="min-width: 350px">
          {{ picker.startDate | date }} - {{ picker.endDate | date }}
        </template>
      </date-range-picker>
      <feather-icon icon="ChevronDownIcon" svgClasses="w-4 h-4" />
    </div>
    <vs-tabs>
      <vs-tab label="Gross Sales">
        <div class="vx-row">
          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="TruckIcon"
              icon-right
              :statistic="POData ? POData.length : 0"
              statisticTitle="Total Supplies"
            />
          </div>

          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="ShoppingBagIcon"
              icon-right
              :statistic="total_sales"
              statisticTitle="Total Sales"
            />
          </div>

          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="ShoppingCartIcon"
              icon-right
              :statistic="gross_sales"
              statisticTitle="Gross Sales"
              color="success"
            />
          </div>

          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="TrendingUpIcon"
              icon-right
              :statistic="gross_profit"
              statisticTitle="Gross Profit"
              color="success"
            />
          </div>

          <!-- <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
          >
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="ClipboardIcon"
              icon-right
              :statistic="parseInt(inventory)"
              statisticTitle="Inventory"
              color="warning"
            />
          </div>

          <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
          >
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="AwardIcon"
              icon-right
              :statistic="parseInt(investment)"
              statisticTitle="Investment"
              color="danger"
            />
          </div>

          <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
          >
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="BarChartIcon"
              icon-right
              :statistic="parseInt(unrealised_profit)"
              statisticTitle="Unrealised Profit"
              color="success"
            />
          </div> -->
        </div>
        <div class="vx-row" v-if="payment_statistics != {}">
          <div
            class="vx-col w-full md:w-1/3 mb-base"
            v-for="payment in payment_statistics"
            :key="payment.id"
          >
            <vx-card :title="payment.n">
              <template slot="actions">
                <vx-tooltip
                  :text="'A summary of sales received using ' + payment.n"
                  position="bottom"
                >
                  <feather-icon
                    icon="HelpCircleIcon"
                    svgClasses="w-6 h-6 text-grey"
                  ></feather-icon>
                </vx-tooltip>
              </template>

              <!-- CHART -->
              <template slot="no-body">
                <div class="mt-10">
                  <vue-apex-charts
                    type="radialBar"
                    height="240"
                    :options="chartOptions"
                    :series="[Math.round((payment.c / total_sales) * 100)]"
                  />
                </div>
              </template>

              <!-- DATA -->
              <div
                class="flex justify-between text-center mt-6"
                slot="no-body-bottom"
              >
                <div
                  class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0"
                >
                  <p class="mt-4">Paid In</p>
                  <p class="mb-4 text-3xl font-semibold">
                    {{ Number(payment.a).toLocaleString() }}
                  </p>
                </div>
                <div
                  class="w-1/2 border border-solid d-theme-border-grey-light border-r-0 border-b-0"
                >
                  <p class="mt-4">Sales Count</p>
                  <p class="mb-4 text-3xl font-semibold">
                    {{ Number(payment.c).toLocaleString() }}
                  </p>
                </div>
              </div>
            </vx-card>
          </div>
        </div>

        <div class="vx-row" v-if="sales && sales.length > 0">
          <div class="vx-col w-full">
            <vx-card title="Sales">
              <div slot="no-body" class="mt-4">
                <vs-table :data="sales" class="table-dark-inverted">
                  <template slot="thead">
                    <vs-th>NO.</vs-th>
                    <vs-th>CASHIER</vs-th>
                    <vs-th>BRANCH</vs-th>
                    <vs-th>PAYMENT METHOD</vs-th>
                    <vs-th>DISCOUNT</vs-th>
                    <vs-th>AMOUNT</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :key="index" v-for="(tr, index) in data">
                      <vs-td>
                        <span># {{ index + 1 }}</span>
                      </vs-td>
                      <vs-td>
                        <span>{{ getUser(tr.cashier) }}</span>
                      </vs-td>
                      <vs-td>
                        <span>{{ tr.branch.branch_name }}</span>
                      </vs-td>
                      <vs-td :data="data[index].payment_method">
                        <span>{{ tr.payment.name }}</span>
                      </vs-td>
                      <vs-td :data="data[index].discount">
                        <span
                          >KES {{ Number(tr.discount).toLocaleString() }}</span
                        >
                      </vs-td>
                      <vs-td :data="data[index].amount">
                        <span
                          >KES {{ Number(tr.amount).toLocaleString() }}</span
                        >
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vx-card>
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Product Reports">
        <div class="vx-row">
          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="ShoppingBagIcon"
              icon-right
              :statistic="parseInt(total_products)"
              statisticTitle="Total Products"
            />
          </div>

          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="BriefcaseIcon"
              icon-right
              :statistic="parseInt(new_products)"
              statisticTitle="New Additions"
            />
          </div>

          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="ShoppingCartIcon"
              icon-right
              :statistic="parseInt(gross_sales)"
              statisticTitle="Gross Sales"
              color="success"
            />
          </div>

          <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4">
            <statistics-card-line
              hideChart
              class="mb-base"
              icon="TrendingUpIcon"
              icon-right
              :statistic="parseInt(gross_profit)"
              statisticTitle="Gross Profit"
              color="success"
            />
          </div>
        </div>

        <div
          class="vx-row mb-base"
          v-if="JSON.stringify(product_statistics) != JSON.stringify({})"
        >
          <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
            <vx-card
              :subtitle="
                `Sales between ${this.parseDate(
                  this.dateRange.startDate
                )} - ${this.parseDate(this.dateRange.endDate)}`
              "
              title="Product Sales"
            >
              <div slot="no-body" class="mt-4">
                <vs-table
                  :data="product_statistics"
                  class="table-dark-inverted"
                >
                  <template slot="thead">
                    <vs-th>PRODUCT CODE</vs-th>
                    <vs-th>PRODUCT NAME</vs-th>
                    <vs-th>AVG. RETAIL PRICE</vs-th>
                    <vs-th>CURRENT RETAIL PRICE</vs-th>
                    <vs-th>TOTAL QUANTITY</vs-th>
                    <vs-th>TOTAL AMOUNT</vs-th>
                    <vs-th>PROFIT</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :key="index" v-for="(tr, index) in data">
                      <vs-td>
                        <span>{{ tr.c }}</span>
                      </vs-td>
                      <vs-td>
                        <span>{{ tr.n }}</span>
                      </vs-td>
                      <vs-td>
                        <span
                          >KES
                          {{ Number(tr.ts / tr.ct).toLocaleString() }}</span
                        >
                      </vs-td>
                      <vs-td>
                        <span>KES {{ Number(tr.s).toLocaleString() }}</span>
                      </vs-td>
                      <vs-td>
                        <span>{{ tr.q }}</span>
                      </vs-td>
                      <vs-td>
                        <span>KES {{ Number(tr.t).toLocaleString() }}</span>
                      </vs-td>
                      <vs-td :data="data[index].p">
                        <span
                          class="text-bold"
                          :class="{
                            'text-success': tr.p > 0,
                            'text-danger': tr.p < 0,
                          }"
                          >KES {{ Number(tr.p).toLocaleString() }}
                        </span>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </vx-card>
          </div>
          <div class="vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2">
            <vx-card title="Product Sales">
              <e-charts autoresize :options="pie" ref="pie" auto-resize />
            </vx-card>
          </div>
        </div>

        <div
          class="vx-col w-full"
          v-if="productAddedData && productAddedData.length"
        >
          <vx-card
            :subtitle="
              `Products added between ${this.parseDate(
                this.dateRange.startDate
              )} - ${this.parseDate(this.dateRange.endDate)}`
            "
            title="New Products"
          >
            <div slot="no-body" class="mt-4">
              <vs-table :data="productAddedData" class="table-dark-inverted">
                <template slot="thead">
                  <vs-th>#</vs-th>
                  <vs-th>PRODUCT CODE</vs-th>
                  <vs-th>PRODUCT NAME</vs-th>
                  <vs-th>RETAIL PRICE</vs-th>
                  <vs-th>COST PRICE</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="index" v-for="(tr, index) in data">
                    <vs-td>
                      <span>{{ index + 1 }}</span>
                    </vs-td>
                    <vs-td>
                      <span>{{ tr.product_code }}</span>
                    </vs-td>
                    <vs-td>
                      <span>{{ tr.product_name }}</span>
                    </vs-td>
                    <vs-td>
                      <span
                        >KES
                        {{
                          Number(
                            tr.retail_price || tr.selling_price
                          ).toLocaleString()
                        }}</span
                      >
                    </vs-td>
                    <vs-td>
                      <span
                        >KES {{ Number(tr.cost_price).toLocaleString() }}</span
                      >
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vx-card>
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import ChangeTimeDurationDropdown from "@/components/ChangeTimeDurationDropdown.vue";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/chart/pie";

import Roller from "vue-roller";
import m from "moment";
import FeatherIcon from "../../../components/FeatherIcon.vue";

export default {
  data() {
    return {
      loading_reports: false,
      date: null,
      date2: new Date(),

      dateRange: {
        startDate: this.getStartDate(new Date()),
        endDate: new Date(),
      },

      total_sales: 0,
      total_jobs: 0,
      gross_sales: 0,
      gross_profit: 0,

      inventory: 0,
      investment: 0,
      unrealised_profit: 0,

      new_products: 0,
      total_products: 0,

      payment_statistics: {},
      product_statistics: {},
      new_product: {},

      chartOptions: {
        plotOptions: {
          radialBar: {
            size: 110,
            startAngle: -150,
            endAngle: 150,
            hollow: {
              size: "77%",
            },
            track: {
              background: "#bfc5cc",
              strokeWidth: "50%",
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                offsetY: 18,
                color: "#99a2ac",
                fontSize: "4rem",
              },
            },
          },
        },
        colors: ["#00db89"],
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "horizontal",
            shadeIntensity: 0.5,
            gradientToColors: ["#00b5b5"],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: "round",
        },
        chart: {
          sparkline: {
            enabled: true,
          },
          dropShadow: {
            enabled: true,
            blur: 3,
            left: 1,
            top: 1,
            opacity: 0.1,
          },
        },
      },
      pie: {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: [],
        },
        series: [
          {
            name: "Product Sales",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            // color: ["#FF9F43", "#28C76F", "#EA5455", "#87ceeb", "#7367F0"],
            data: [],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
    };
  },
  pouch: {
    saleData() {
      return {
        database: "express",
        selector: {
          type: "sale",
          date_created: {
            $gte:
              new Date(this.getStartDate(this.dateRange.startDate)).getTime() ||
              new Date().getTime(),
            $lt:
              new Date(this.getEndDate(this.dateRange.endDate)).getTime() ||
              new Date().getTime(),
          },
        },
        sort: [
          {
            date_created: "desc",
          },
        ],
      };
    },
    productData() {
      return {
        database: "express",
        selector: {
          type: "product",
        },
      };
    },
    productAddedData() {
      return {
        database: "express",
        selector: {
          type: "product",
          date_created: {
            $gte:
              new Date(this.getStartDate(this.dateRange.startDate)).getTime() ||
              new Date().getTime(),
            $lt:
              new Date(this.getEndDate(this.dateRange.endDate)).getTime() ||
              new Date().getTime(),
          },
        },
      };
    },
    POData() {
      return {
        database: "express",
        selector: {
          type: "purchase",
          date_created: {
            $gte:
              new Date(this.getStartDate(this.dateRange.startDate)).getTime() ||
              new Date().getTime(),
            $lt:
              new Date(this.getEndDate(this.dateRange.endDate)).getTime() ||
              new Date().getTime(),
          },
        },
      };
    },
    branchData() {
      return {
        database: "express",
        selector: {
          type: "branch",
        },
      };
    },
    userData() {
      return {
        database: "express",
        selector: {
          type: "user",
        },
      };
    },
  },
  computed: {
    validate() {
      return (
        this.dateRange.startDate &&
        this.dateRange.endDate &&
        !this.loading_reports
      );
    },
    products() {
      let p = this.productData || [];
      this.total_products = p.length;
      this.new_products = this.productAddedData
        ? this.productAddedData.length
        : [];
      return p;
    },
    sales() {
      let s = this.saleData || [];
      let ps = {};
      let ts = 0;
      let sp = {};
      let gp = 0;
      if (s.length > 0) {
        for (let i = 0; i < s.length; i++) {
          const e = s[i];
          const pid = e.payment._id;
          ts = ts + parseInt(e.amount);
          if (ps.hasOwnProperty(pid)) {
            ps[pid].c = ps[pid].c + 1;
            ps[pid].a = ps[pid].a + parseInt(e.amount);
          } else {
            ps[pid] = {
              c: 1,
              n: e.payment.name,
              a: parseInt(e.amount),
            };
          }
          if (typeof e.products === "object" || typeof e.products === "array") {
            for (let j = 0; j < e.products.length; j++) {
              const p = e.products[j];
              if (sp.hasOwnProperty(p._id)) {
                sp[p._id].p =
                  sp[p._id].p +
                  (parseInt(p.selling_price || p.retail_price) -
                    parseInt(p.cost_price));
                sp[p._id].q = sp[p._id].q + parseInt(p.q || 1);
                sp[p._id].t =
                  sp[p._id].t +
                  parseInt(p.q || 0) *
                    parseInt(p.selling_price || p.retail_price);
                sp[p._id].ct = sp[p._id].ct + 1;
                sp[p._id].ts =
                  sp[p._id].ts + parseInt(p.selling_price || p.retail_price);
                gp = gp + sp[p._id].p;
              } else {
                sp[p._id] = {
                  c: p.product_code,
                  n: p.product_name,
                  c: parseInt(p.cost_price),
                  s: parseInt(p.selling_price || p.retail_price),
                  ts: parseInt(p.selling_price || p.retail_price),
                  p:
                    parseInt(p.selling_price || p.retail_price) -
                    parseInt(p.cost_price),
                  q: parseInt(p.q || 0),
                  t:
                    parseInt(p.q || 0) *
                    parseInt(p.selling_price || p.retail_price),
                  ct: 1,
                };
                gp = gp + sp[p._id].p;
                // this.pie.series[0].data.push()
              }
            }
            console.log(sp);
            this.pie.series[0].data = [];
            this.pie.series[0].color = [];
            this.pie.legend.data = [];
            for (const k in sp) {
              if (sp.hasOwnProperty(k)) {
                const pd = sp[k];
                this.pie.legend.data.push(
                  `${pd.n} (KES ${Number(pd.t).toLocaleString()})`
                );
                this.pie.series[0].data.push({
                  value: pd.ct,
                  name: `${pd.n} (KES ${Number(pd.t).toLocaleString()})`,
                });
              }
            }
          }
        }
      }
      this.$vs.loading.close();
      this.total_sales = s.length;
      this.gross_sales = ts;
      this.gross_profit = gp;
      this.payment_statistics = ps;
      this.product_statistics = sp;
      return s;
    },
  },
  methods: {
    generateColor(str) {
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      var colour = "#";
      for (var i = 0; i < 3; i++) {
        var value = (hash >> (i * 8)) & 0xff;
        colour += ("00" + value.toString(16)).substr(-2);
      }
      return colour;
    },
    addDays(date, days) {
      const c = new Date(Number(date));
      c.setDate(date.getDate() + days);
      return c;
    },
    getUser(id) {
      var b = "N/A";
      if (this.userData !== null) {
        var c = this.userData.find((e) => e._id == id);
        if (typeof c == "object") {
          b = c.name;
        }
      }
      return b;
    },
    getStartDate(d) {
      d.setHours(0, 0, 0, 0);
      return d;
    },
    getEndDate(d) {
      d.setHours(23, 59, 59, 59);
      return d;
    },
    getProduct(z) {
      var data = this.$store.state.products.products.find((x) => x.id == z);
      if (data) {
        return data["product_name"];
      }
      return;
    },
    parseDate(x) {
      return this.$moment(x).format("ddd DD MMM YYYY hh:mm a");
    },
    getDate(x) {
      return this.$moment(x).format("YYYY-MM-DD hh:mm:ss");
    },
    getPaymentMethod(z) {
      var data = this.$store.state.finance.paymentMethods.find(
        (x) => x.id == z
      );
      if (data) {
        return data;
      }
      return;
    },
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    DateRangePicker,
    Datepicker,
    Roller,
    FeatherIcon,
    ECharts,
  },
  created() {
    this.$vs.loading();
  },
  mounted() {
    // let dataIndex = -1;
    // let pie = this.$refs.pie;
    // let dataLen = this.pie.options.series[0].data.length;
    // setInterval(() => {
    //   pie.dispatchAction({
    //     type: "downplay",
    //     seriesIndex: 0,
    //     dataIndex,
    //   });
    //   dataIndex = (dataIndex + 1) % dataLen;
    //   pie.dispatchAction({
    //     type: "highlight",
    //     seriesIndex: 0,
    //     dataIndex,
    //   });
    //   pie.dispatchAction({
    //     type: "showTip",
    //     seriesIndex: 0,
    //     dataIndex,
    //   });
    // }, 1000);
  },
};
</script>
